export interface filterButtonInterface {
  label: string;
  setNewSelectedCategories: (label: string) => void;
  isSelected: boolean;
}

function FilterButton({
  label,
  setNewSelectedCategories,
  isSelected,
}: filterButtonInterface) {
  return (
    <button
      id="filter-button"
      className={`border-2 border-primary rounded-3xl w-fit px-3 ${isSelected ? "bg-ultramarine text-butter hover:bg-butter hover:text-ultramarine" : "hover:bg-ultramarine hover:text-butter"}  font-raleway font-bold`}
      onClick={() => {
        setNewSelectedCategories(label);
      }}
    >
      {label}
    </button>
  );
}

export default FilterButton;
